import React from 'react'
import { Chapter, } from './'
import uuid from 'uuid/v1'

// Access Book PDF at http://localhost:3000/book/print
// See "AssessDirectionsModal" for example of how to set HTML content (dangerouslySetHTML)

export default function Book({ bookTitle, bookContent }) {
  return (
    <html>
      <head>
        <meta charSet="UTF-8" />
        <title>{bookTitle}</title>

        <link rel="stylesheet" href="https://bellwork-cg1.firebaseapp.com/img/main.css" type="text/css" />

        <link href="https://fonts.googleapis.com/css?family=Bitter|Open+Sans:400,700" rel="stylesheet" />

      </head>

      <body>
        <footer>
          <img src="https://bellwork-cg1.firebaseapp.com/img/masteryprep-logo.svg" alt="MasteryPrep Logo" />
        </footer>

         {/*
            Iterates over Chapters.
            Passess along Chapter Props.
         */}

        {bookContent.chapters.map(chapter =>
          <Chapter
            chapterTitle={chapter.title}
            chapterSections={chapter.sections}
            key={uuid()}
          />
        )}

      </body>
    </html>
  )
}


// WEBPACK FOOTER //
// ./src/components/BookPrint/Book.js